<ng-container *ngIf="isImage">
    {{title}} - <img src="{{imageUrl}}">
</ng-container>




